module.exports = "<div class=\"captainInvoice\">captainInvoice</div>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/captainInvoice/captainInvoice.html
// module id = 1712
// module chunks = 0